import script from "./dashboardMockData.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardMockData.vue?vue&type=script&setup=true&lang=js"

import "./dashboardMockData.vue?vue&type=style&index=0&id=724850d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724850d3"]])

export default __exports__